import type { JSX } from "preact";

interface Props {
    name: string;
}

export function ExportRawDisclaimer({ name }: Props): JSX.Element {
    return (
        <>
            <p>
                Observera att {name} är att betrakta som personinformation.
                Filen du laddar ner behöver därför sparas ner på en säker plats.
                Din dators hårddisk är inte att betrakta som en säker plats. Om
                du är osäker på vad som är en säker plats, fråga en
                informationssäkerhetskunnig hos er internt.
            </p>

            <p>
                I inställningar i din webbläsare kan du ställa in så att du
                alltid blir tillfrågad vart du ska spara en fil som laddas ner.
                Det är viktigt att du gör den inställningen innan du klickar på
                filen.
                <br />
                Din region kan ha särskilda bestämmelser för hur
                personinformation får hanteras internt, men generellt gäller att
                om du först behöver spara ner filen temporärt, t.ex. i Hämtade
                filer, behöver den raderas därifrån så snart du sparat ner den
                på en säker plats. Du kan även ställa in så att hämtade filer
                raderas automatiskt.
            </p>

            <p>
                Var noga med att endast dela filen med behöriga. Filen får inte
                skickas via vanlig mejl utan endast med någon säker tjänst för
                filöverföring. Informationen i filen får heller inte användas i
                molntjänster som t.ex. Chat GPT eller publiceras publikt.
            </p>
        </>
    );
}
